<template>
  <div class="checkout-builder-countdown-preview" :style="style">
    <bp-icon size="32" icon="fa-regular fa-clock" />
    <!-- <span class="mx-3 fw-6">{{ hours }}:{{ minutes }}:{{ seconds }}</span> -->
    <h2 class="mx-3 fw-6">{{ hours }}:{{ minutes }}:{{ seconds }}</h2>
    <!-- <span>{{ component.countdownText }}</span> -->
    <span class="functional-1">Essa oferta irá expirar...</span>
  </div>
</template>

<script>
let timeout;
export default {
  props: {
    component: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      innerTime: 0
    };
  },
  computed: {
    hours() {
      return this.format(this.innerTime / (60 * 60));
    },
    minutes() {
      return this.format((this.innerTime / 60) % 60);
    },
    seconds() {
      return this.format(this.innerTime % 60);
    },
    style() {
      return {
        // color: this.component?.countdownTextColor,
        // backgroundColor: this.component?.countdownBackgroundColor
        background: "#ee6469",
        color: "white"
      };
    }
  },
  mounted() {
    this.startTimer(parseInt(this.component?.countdownTime || 0));
  },
  methods: {
    format(number) {
      return `${Math.floor(number)}`.padStart(2, "0");
    },
    count() {
      if (this.innerTime > 0) {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          this.innerTime--;
          this.count();
        }, 1000);
      }
    },
    startTimer(time) {
      this.innerTime = time;
      this.count();
    }
  },
  watch: {
    "component.countdownTime"(v) {
      this.startTimer(v);
    }
  }
};
</script>

<style lang="scss" scoped>
.checkout-builder-countdown-preview {
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
